"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Product = babelHelpers.interopRequireDefault(require("Product"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _class, _descriptor, _temp;

var ProductDetailPage = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ProductDetailPage, _Component);

  function ProductDetailPage() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ProductDetailPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ProductDetailPage)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "content", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ProductDetailPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "page-content-container"
      }, _react.default.createElement("div", {
        "data-product": "true"
      }, _react.default.createElement(_Product.default, this.content)));
    }
  }]);
  return ProductDetailPage;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = ProductDetailPage;